import React from 'react';
import {Skeleton, Table} from '@chakra-ui/react';
import styles from '../completed/styles.module.scss';
import {BREAKPOINTS} from '../../../../constants';
import useWindowSize from 'hooks/useWindowSize';

const TabsSkeleton: React.FC = () => {
  const {width} = useWindowSize();

  return (
    <Table.Row>
      <Table.Cell>
        <Skeleton height="30px" width="100%" className={styles.skeleton} />
      </Table.Cell>
      <Table.Cell>
        <Skeleton height="30px" width="100%" className={styles.skeleton} />
      </Table.Cell>
      {width > BREAKPOINTS.LG ? (
        <>
          <Table.Cell>
            <Skeleton height="30px" width="100%" className={styles.skeleton} />
          </Table.Cell>
          <Table.Cell>
            <Skeleton height="30px" width="100%" className={styles.skeleton} />
          </Table.Cell>
          <Table.Cell>
            <Skeleton height="30px" width="100%" className={styles.skeleton} />
          </Table.Cell>
          <Table.Cell>
            <Skeleton height="30px" width="100%" className={styles.skeleton} />
          </Table.Cell>
          <Table.Cell>
            <Skeleton height="30px" width="100%" className={styles.skeleton} />
          </Table.Cell>
        </>
      ) : (
        <Table.Cell>
          <Skeleton height="30px" width="100%" className={styles.skeleton} />
        </Table.Cell>
      )}
    </Table.Row>
  );
};

export default TabsSkeleton;
